import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Heart, Sparkles, Users, User, ArrowRight } from "lucide-react";
import heroImage from "@/assets/hero-bg.jpg";
import { useTranslation } from "@/hooks/useTranslation";

// Import boyfriend avatars
import romanticAvatar from "@/assets/avatar-romantic.jpg";
import badboyAvatar from "@/assets/avatar-badboy.jpg";
import intellectualAvatar from "@/assets/avatar-intellectual.jpg";
import protectorAvatar from "@/assets/avatar-protector.jpg";
import funnyAvatar from "@/assets/avatar-funny.jpg";
interface HeroSectionProps {
  onGetStarted: () => void;
  onLogin: () => void;
  onNavigateToMyBoyfriends?: () => void;
  onSelectBoyfriend?: (boyfriend: any) => void;
}
export const HeroSection = ({
  onGetStarted,
  onLogin,
  onNavigateToMyBoyfriends,
  onSelectBoyfriend
}: HeroSectionProps) => {
  const { t } = useTranslation();
  
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-8">
      {/* Login button in upper right corner */}
      <div className="absolute top-6 right-6 z-30">
        
      </div>
      
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-dreamy" />
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: `url(${heroImage})`
    }} />
      
      
      {/* Main content */}
      <div className="relative z-20 text-center max-w-4xl mx-auto px-4">
        <div className="animate-fade-in">
          {/* Logo */}
          <div className="mb-6 flex items-center justify-center gap-2">
            <Heart className="h-6 w-6 md:h-8 md:w-8 text-primary bg-transparent" />
            <h1 className="text-3xl md:text-4xl font-bold bg-gradient-romantic bg-clip-text text-transparent">
              DreamBoyfriend
            </h1>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-6 bg-gradient-romantic bg-clip-text text-transparent">
            {t('hero.title')}
          </h1>
          
          
          <div className="flex flex-col gap-4 justify-center items-center mb-12">
            <p className="text-muted-foreground text-sm animate-fade-in">
              <Users className="h-4 w-4 inline mr-1" />
              {t('hero.join_users')}
            </p>
            
            <Button variant="dreamy" size="xl" onClick={onGetStarted} className="animate-scale-in">
              <Heart className="h-5 w-5 mr-2" />
              {t('hero.get_started')}
            </Button>
            
            <p className="text-sm text-muted-foreground mt-12">
              {t('auth.have_account')}{" "}
              <button 
                onClick={onLogin}
                className="text-primary hover:underline font-medium"
              >
                {t('hero.sign_in')}
              </button>
            </p>
          </div>
          
          {/* Browse Pre-Created Boyfriends Section */}
          <div className="mt-16 max-w-6xl mx-auto">
            
            
            
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
};